import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

export const initSentry = (
  app: App<Element>,
  router: Router,
  options?: {
    dsn?: string;
    tracesSampleRate?: number;
    tracePropagationTargets?: (string | RegExp)[];
    replaysSessionSampleRate?: number;
    replaysOnErrorSampleRate?: number;
    enableReplay?: boolean;
    environment: string;
  },
) => {
  // Prevent Sentry on localhost or development
  const env = import.meta.env.VITE_BASE_ENV_URL || 'development';
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isPreviewEnv = window.location.hostname === 'dev-cdp-portal-v2-preview.azurewebsites.net';

  if (isPreviewEnv || isLocalhost) {
    return; // Do not initialize Sentry
  }

  const {
    dsn = 'https://a9e4be425a459249a6e35600f8b2810c@sentry.chococrm.com/8',
    tracesSampleRate = 1.0,
    tracePropagationTargets = ['dev-cdp-portal-v2.azurewebsites.net', 'cdp-portal-v2-linux.azurewebsites.net', 'portal.chococdp.com'],
    replaysSessionSampleRate = 0.1,
    replaysOnErrorSampleRate = 1.0,
    enableReplay = true,
  } = options || {};

  const integrations = [Sentry.browserTracingIntegration({ router })];
  if (enableReplay) {
    integrations.push(Sentry.replayIntegration());
  }

  Sentry.init({
    app,
    dsn,
    integrations,
    tracesSampleRate,
    tracePropagationTargets,
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    environment: env,
  });
};
